import styles from './TestBeacons.module.css'

interface TestBeaconsProps {
    identifier: string
    /** Number of lookups to force. Each image is a distinct subdomain. */
    count?: number
}

/**
 * The mechanism of the whole test: each image sits on its own subdomain of a
 * token unique to this run, so loading them forces the browser's resolvers to
 * make that many DNS lookups. The authoritative server records who asked.
 *
 * These are pure side effect and carry no information, so they are aria-hidden
 * with empty alt text -- the old UI gave all fifty alt="1px", which a screen
 * reader announced fifty times.
 */
export default function TestBeacons({ identifier, count = 50 }: TestBeaconsProps) {
    const host = `${identifier}.test.${window.location.host}`

    return (
        <div className={styles.beacons} aria-hidden="true">
            {Array.from({ length: count }, (_, i) => (
                <img key={i} src={`https://${i}.${host}/test${i}.png`} alt="" width={1} height={1} />
            ))}
        </div>
    )
}
